import React from 'react';

const CreateCategoryModal = ({ isOpen, categoryName, onChangeName, onCreate, onCancel }) => {
  if (!isOpen) return null;

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#343541] rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Create New Category</h2>
          <button onClick={handleCancel} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-300 mb-2">Category Name</label>
          <input
            type="text"
            value={categoryName}
            onChange={e => onChangeName(e.target.value)}
            className="w-full bg-[#23242a] rounded-lg px-4 py-2 text-white border border-gray-700 focus:border-[#19C37D] focus:ring-1 focus:ring-[#19C37D]"
            placeholder="Enter category name..."
            onKeyDown={e => {
              if (e.key === 'Enter') {
                onCreate();
              } else if (e.key === 'Escape') {
                handleCancel();
              }
            }}
            autoFocus
          />
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCreate}
            disabled={!categoryName.trim()}
            className="flex-1 bg-[#f5f5f0] text-gray-800 py-2 px-4 rounded-lg hover:bg-[#e8e8e0] transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
          >
            Create
          </button>
          <button
            onClick={handleCancel}
            className="flex-1 bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors font-semibold"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export { CreateCategoryModal };
